import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
//import Login from '@/views/Login.vue';
import Main from '@/views/Main.vue';
import Dashboard from '@/views/Dashboard.vue';
import Resumen from '@/views/Resumen.vue';
import Recibos from '@/views/recibos/Recibo.vue';
import Autorizacion from '@/views/autorizacionComprobantes/MainAutorizacion.vue';
import OrdenesCompra from '@/views/ordenesCompra/MainOrdenes.vue';
import Cereales from '@/views/Granos.vue';
import Contratos from '@/views/Contratos.vue';
import CFiscales from '@/views/Cfiscales.vue';
import Remitos from '@/views/Remitos.vue';

import PosicionStockVentas from '@/views/PosicionStockVentas.vue';
import Pedidos from '@/views/pedidos/Pedidos.vue';
import Producto from '@/components/Producto.vue';
import Historial from '@/components/Historial.vue';
import DashboardP from '@/components/DashboardProductos.vue';
import Login from '@/views/Login.vue';
import Welcome from '@/views/Welcome.vue';
import Forgot from '@/views/Forgot.vue';
// Reparto
import Visitas from '@/views/reparto/Visitas.vue';
import DetalleCliente from '@/views/reparto/DetalleCliente.vue';
import Envases from '@/views/reparto/Envases.vue';
// Almacenes
import Almacenes from '@/views/almacenes/Almacenes.vue';
import DetalleAlmacenes from '@/views/almacenes/DetalleAlmacenes.vue';
// Stock
import Stock from '@/views/stock/Stock.vue';

//import Usuarios from '@/views/Usuarios.vue';

Vue.use(Router);

const router = new Router({
	mode: 'hash',
	routes: [
		{
			path: '/',
			component: Login,
			children: [
				{
					path: '/forgot',
					name: 'Forgot',
					component: Forgot,
					children: [
						{
							path: '/forgot/:hash',
						},
					],
				},
				{
					path: '/welcome',
					//alias: '/welcome',
					name: 'Welcome',
					component: Welcome,
					children: [
						{
							path: '/welcome/signin',
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: '/welcome/signup',
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: '/welcome/sessions',
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: '/welcome/new',
							meta: {
								requiresAuth: true,
							},
						},
					],
				},
			],
		},
		{
			path: '/:profile',
			component: Main,
			meta: {
				requiresAuth: true,
			},
			children: [
				{
					path: '/:profile/stock',
					name: 'Stock',
					component: Stock,
				},
				{
					path: '/:profile/almacenes',
					name: 'Almacenes',
					component: Almacenes,
				},
				{
					path: '/:profile/detalleAlmacenes',
					name: 'detalleAlmacenes',
					component: DetalleAlmacenes,
				},
				{
					path: '/:profile/dashboard',
					name: 'Dashboard',
					component: Dashboard,
					meta: {
						btnDownload: false,
					},
				},
				{
					path: '/:profile/cronologico',
					name: 'Resumen Cronológico',
					component: Resumen,
					meta: {
						btnDownload: true,
					},
				},
				{
					path: '/:profile/financiero',
					name: 'Resumen Financiero',
					component: Resumen,
					meta: {
						btnDownload: true,
					},
				},
				{
					path: '/:profile/granos',
					name: 'Ficha de Granos',
					component: Cereales,
					meta: {
						btnDownload: true,
					},
					children: [
						{
							path: ':grano',
							meta: {
								btnDownload: true,
							},
							children: [
								{
									path: ':cosecha',
								},
							],
						},
					],
				},
				{
					path: '/:profile/canje',
					name: 'Canjes',
					component: Resumen,
					meta: {
						btnDownload: true,
					},
				},
				{
					path: '/:profile/contratos',
					redirect: to => `/${to.params.profile}/contratos/1`,
					meta: { btnDownload: true, requiresAuth: true },
				},
				{
					path: '/:profile/contratos/:grano',
					name: 'ContratosGrano',
					component: Contratos,
					meta: { btnDownload: true, requiresAuth: true },
					props: true,
					// path: '/:profile/contratos',
					// name: 'Contratos',
					// component: Contratos,
					// meta: {
					// 	btnDownload: true,
					// },
					// children: [
					// 	{
					// 		path: ':grano',
					// 	},
					// ],
				},
				{
					path: '/:profile/cfiscales',
					name: 'Comprobantes Fiscales',
					component: CFiscales,
					meta: {
						btnDownload: true,
					},
				},
								{
					path: '/:profile/remitos',
					name: 'Remitos',
					component: Remitos,
					meta: {
						btnDownload: true,
					},
				},
				{
					path: '/:profile/recibos',
					name: 'Recibos',
					component: Recibos,
					meta: {
						btnDownload: false,
					},
				},
				{
					path: '/:profile/autorizacion',
					name: 'Autorización de comprobantes',
					component: Autorizacion,
					meta: {
						btnDownload: false,
					},
				},
				{
					path: '/:profile/ordenescompra',
					name: 'Ordenes de compra',
					component: OrdenesCompra,
					meta: {
						btnDownload: false,
						showCarritoOrden: true,
					},
				},
				{
					path: '/:profile/posicionstockventas',
					name: 'Posicion de Stock de Ventas',
					component: PosicionStockVentas,
					meta: {
						btnDownload: true,
					},
				},
				// {
				// 	path: '/:profile/usuarios',
				// 	name: 'Usuarios',
				// 	component: Usuarios,
				// },
				{
					path: '/:profile/pedidos',
					name: 'Pedidos',
					component: Pedidos,
					meta: {
						btnDownload: false,
						showCarrito: true,
					},
					children: [
						{
							path: 'detalle/:producto',
							name: 'Producto',
							component: Producto,
							props: true,
							meta: {
								btnDownload: false,
								showCarrito: true,
							},
						},
						{
							path: 'dashboard',
							name: 'dashboardproductos',
							component: DashboardP,
						},
						{
							path: 'historial',
							name: 'Historial',
							component: Historial,
						},
					],
				},
				{
					path: '/:profile/repartos',
					name: 'Visitas',
					component: Visitas,
				},
				{
					path: '/:profile/detalle-cliente/:id?/:fecha',
					name: 'DetalleCliente',
					component: DetalleCliente,
					props: true,
				},
				{
					path: '/:profile/envases',
					name: 'Envases',
					component: Envases,
				},
			],
		},
	],
});

let initialBoot = true;
router.beforeEach((to, from, next) => {
	// if (to.path === '/welcome/sessions' || to.path === '/welcome/new') {
	// 	if (store.getters.isAuthenticated) {
	// 		next();
	// 		return;
	// 	}
	// 	next('/welcome');
	// }
	console.log(to.path);
	if (to.path.includes('/forgot/') || to.path === '/welcome/signup' || to.path === '/welcome/signin') {
		next();
		return;
	}
	if (from.path === '/' && !store.getters.getActiveHost && initialBoot) {
		initialBoot = false;
		next('/welcome/sessions');
		return;
	} else if (to.matched.some(record => record.meta.requiresAuth)) {
		if (store.getters.isAuthenticated) {
			next();
			return;
		}
		next('/welcome');
		// next('/almacenes');
	} else if (store.getters.isAuthenticated) next();
	// } else if (store.getters.isAuthenticated) next(from.path);
	else next();
});

export default router;
